<template>
  <div>
    <div
        class="modal show fade modal text-left "
        style="display: block;"
        v-if="show"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">
              WithDrawl Method Details
            </h4>
            <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                @click="$emit('hide')"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="card">
              <div class="card-body" v-if="this.list && !this.isEmpty(this.list)">
                <div
                    class="d-flex align-items-center pb-3 border-bottom mb-3"
                    v-for="(listValue, listKey) in list"
                    :key="listKey"
                >
                  <div class="mr-auto">
                    <h6 class="fs-16 font-w600 mb-0">
                      <a
                          href="javascript:void(0)"
                          class="text-warning  font-weight-bolder"
                      >{{ decodeURI(listKey) }}</a
                      >
                    </h6>
                  </div>
                  <span
                      style="font-size: larger"
                      class=" font-weight-bolder text-dark"
                  >
                    <h6
                        style="fs-16 font-w600 mb-0 overflow: auto; word-break: break-all"
                    >
                      <a
                          href="javascript:void(0)"
                          class="text font-weight-bolder"
                      >
                        {{ decodeURI(listValue) }}</a
                      >
                    </h6>
                  </span>
                </div>
              </div>
              <div class="card-body text-center text-primary" v-else>
                No Details Avaliable
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
                @click="$emit('hide')"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  props: ['show', 'data', 'index'],
  data() {
    return {
      list: []
      // showModal: false,
    };
  },
  methods: {
  },
  watch: {
    show() {
      this.list = this.data
    },
  }
};
</script>

<style scoped>
.modal{
  display: block !important; /* I added this to see the modal, you don't need this */
}

/* Important part */
.modal-dialog{
  overflow-y: initial !important
}
.modal-body{
  height: 70vh;
  overflow-y: auto;
}
</style>
